import React from 'react';
import { luxColors } from '@alucio/lux-ui';
const Container = {
    display: 'flex',
    alignItems: 'flex-end',
};
const STEP = 3;
export default function NetworkQualityLevel({ qualityLevel }) {
    if (qualityLevel === null)
        return null;
    return (React.createElement("div", { style: Container }, [0, 1, 2, 3, 4].map(level => (React.createElement("div", { key: level, style: {
            height: `${STEP * (level + 1)}px`,
            background: qualityLevel > level ? '#0c0' : '#005100',
            width: '2px',
            border: `1px solid ${luxColors.opacityBackground.darker}`,
            boxSizing: 'content-box',
            borderRight: 'none',
        } })))));
}
//# sourceMappingURL=NetworkQualityLevel.js.map